import flatpickr from 'flatpickr';
import moment from 'moment';

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.bulk')) {
        const dateRangeField = document.querySelector('.bulk__date-field');
        flatpickr(dateRangeField, {
            mode: 'range',
            dateFormat: 'm/d/Y',
            wrap: true,
            static: true,
            onValueUpdate: (selectedDates, dateStr, instance) => {
                // Validate that the date range is less than 31 days.
                const [rawFromDate, rawToDate] = selectedDates;
                if (!rawToDate) {
                    return;
                }
                const fromDate = moment(rawFromDate.toISOString(), moment.ISO_8601);
                const toDate = moment(rawToDate.toISOString(), moment.ISO_8601);
                const difference = toDate.diff(fromDate, 'days');
                if (difference > 31) {
                    instance.clear();
                }
            },
            onClose: (selectedDates, dateStr, instance) => {
                if (selectedDates.length == 1) {
                    instance.setDate([selectedDates[0],selectedDates[0]], true);
                }
            }
        });
    }
});